import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logoRD from "./assets/logoasesor.png";
import './styles/disenoblog.css';

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [postsOriginales, setPostsOriginales] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    obtenerTodosLosPosts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Filtrado en tiempo real
  useEffect(() => {
    if (!busqueda.trim()) {
      setPosts(postsOriginales);
      return;
    }
    filtrarPosts(busqueda);
  }, [busqueda, postsOriginales]); // eslint-disable-line react-hooks/exhaustive-deps

  const obtenerTodosLosPosts = async () => {
    try {
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/posts", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const text = await response.text();
      const data = text ? JSON.parse(text) : [];
      setPosts(data);
      setPostsOriginales(data);
    } catch (error) {
      console.error("Error al obtener posts:", error);
    }
  };

  const filtrarPosts = async (texto) => {
    try {
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/busquedablog", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ titulo: texto }),
      });

      const text = await response.text();
      const data = text ? JSON.parse(text) : [];
      setPosts(data);
    } catch (error) {
      console.error("Error al buscar posts:", error);
    }
  };

  return (
    <div className="blog-container">
      {/* BARRA DE NAVEGACIÓN */}
      <header className="blog-header">
        <div className="blog-header-left">
          <img src={logoRD} alt="Logoasesor" className="blog-logo" />
        </div>
        <nav className="blog-nav">
          <span onClick={() => navigate("/")} className="blog-nav-link">Menu Principal</span>
          <span onClick={() => navigate("/pantallaCIT")} className="blog-nav-link">Asesoría</span>
          <span onClick={() => navigate("/", { state: { scrollTo: "planes" } })} className="blog-nav-link">Planes de ahorro</span>
          <span onClick={() => navigate("/", { state: { scrollTo: "simulador" } })} className="blog-nav-link">Simulador</span>
          <span onClick={() => navigate("/", { state: { scrollTo: "seguros" } })} className="blog-nav-link">Seguros</span>
          <span onClick={() => navigate("/contacto")} className="blog-nav-link">Contacto</span>
          <span onClick={() => navigate("/blog")} className="blog-nav-link">Blog</span>
        </nav>
        <div className="blog-header-info">
          📞 +52 (653) 103-8410 | ✉️ ricardodiaztuasesorfinanciero@gmail.com
        </div>
      </header>

      {/* BARRA DE BÚSQUEDA DEBAJO DE LA NAVBAR */}
      <div className="blog-search-container">
        <input
          type="text"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder="Buscar por título..."
          className="blog-search-input"
        />
        <button className="blog-search-button">🔍 Buscar</button>
      </div>

      {/* CONTENIDO DEL BLOG */}
      <div className="blog-content">
        <div className="blog-header-section">
          <h2 className="blog-title">📰 Blog de Finanzas</h2>
          <p className="blog-subtitle">Consejos, novedades y temas de interés sobre ahorro y seguros.</p>
        </div>

        {posts.map((post) => (
          <div key={post.id} className="blog-post-card">
            <h3 className="blog-post-title">{post.titulo}</h3>
            <p className="blog-post-content">{post.contenido}</p>
            <div className="blog-image-gallery">
              {post.imagen1 && (
                <img src={`data:image/jpeg;base64,${post.imagen1}`} alt="imagen1" className="blog-image" />
              )}
              {post.imagen2 && (
                <img src={`data:image/jpeg;base64,${post.imagen2}`} alt="imagen2" className="blog-image" />
              )}
              {post.imagen3 && (
                <img src={`data:image/jpeg;base64,${post.imagen3}`} alt="imagen3" className="blog-image" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


